import Vue from 'vue'
import Router from 'vue-router'
//import  VueHammer  from 'vue2-hammer'

//import Welcome from '@/components/Welcome'
const Welcome = () => import(/* webpackChunkName" "Welcome" */ '@/components/Welcome');
//import ImgSelect from '@/components/ImgSelect'
const ImgSelect = () => import(/* webpackChunkName: "ImgSelect" */ '@/components/ImgSelect.vue');

//import work from '@/components/work'
const work = () => import(/* webpackChunkName: "work" */ '@/components/work.vue');

//import Mobilework from '@/components/Mobilework'
const Mobilework = () => import(/* webpackChunkName: "Mobilework" */ '@/components/Mobilework.vue');
//import MobileCheckout from '@/components/MobileCheckout'
const MobileCheckout = () => import(/* webpackChunkName: "MobileCheckout" */ '@/components/MobileCheckout.vue');

//import CreditCard from '@/components/CreditCard'

const CreditCard = () => import(/* webpackChunkName: "CreditCard" */ '@/components/CreditCard.vue');
//import CheckOut from '@/components/CheckOut'
const CheckOut = () => import(/* webpackChunkName: "CheckOut" */ '@/components/CheckOut.vue');

//import Cart    from '@/components/Cart'
const Cart = () => import(/* webpackChunkName: "Cart" */ '@/components/Cart.vue');

//import MobileCart from '@/components/MobileCart'
const MobileCart = () => import(/* webpackChunkName: "MobileCart" */ '@/components/MobileCart.vue');

//import ThankYou from '@/components/ThankYou'
const ThankYou = () => import(/* webpackChunkName: "ThankYou" */ '@/components/ThankYou.vue');

//import MobileThankYou from '@/components/MobileThankYou'
const MobileThankYou = () => import(/* webpackChunkName: "MobileThankYou" */ '@/components/MobileThankYou.vue');

//import GoodAuth from '@/components/GoodAuth'
const GoodAuth = () => import(/* webpackChunkName: "GoodAuth" */ '@/components/GoodAuth.vue');

//import BadAuth from '@/components/BadAuth'
const BadAuth = () => import(/* webpackChunkName: "BadAuth" */ '@/components/BadAuth.vue');

//import Auth from '@/components/Auth'
const Auth = () => import(/* webpackChunkName: "Auth" */ '@/components/Auth.vue');

//import VIP from '@/components/VIP'
//const VIP = () => import(/* webpackChunkName: "VIP" */ '@/components/VIP.vue');

const Invoice = () => import(/* webpackChunkName: "Invoice" */ '@/components/Invoice.vue');

const SetInvoice = () => import(/* webpackChunkName: "SetInvoice" */ '@/components/SetInvoice.vue');
//import animate from '@/assets/animate.css';
//import normal from '@/assets/normalize.css';

const Disclaimer = () => import(/* webpackChunkName: "Disclaimer" */ '@/components/Disclaimer.vue');
const Faq  = () => import(/* webpackChunkName: "Faq" */ '@/components/FAQ.vue');


//Vue.use(VueHammer)
Vue.use(Router)


function unstableJson(route)  {
return {
    //layer: JSON.parse(decodeURI(route.params.layer)) 
    //layer: JSON.parse(decodeURI(route.params.layer)) 
    layer: JSON.parse(route.params.layer) 
    //layer: route.params.layer 
  }
}

function unstableInvoice(route)  {
return {
    invoiceID: JSON.parse(route.params.invoiceID) 
  }
}

export default new Router({
  //mode: 'history',
  scrollBehavior: function (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
   {
      path: '/',
      name: 'Welcome',
      component: Welcome 
    },
    {
      path: '/https://www.heidelberg.org/recent-news/2018/5/7/curate-your-own-tyree-guyton-art-print/',
      name: 'Welcome',
      component: Welcome 
    },

    {
      path: '/work',
      name: 'work',
      component: work 
    },
    {
      path: '/credit',
      name: 'CreditCard',
      component: CreditCard 
    },
    {
      path: '/checkout/:layer',
      name: 'checkout',
      props: unstableJson,
      component: CheckOut 
    },
    {
      path: '/setInvoice/:layer',
      name: 'SetInvoice',
      props: unstableJson,
      component: SetInvoice 
    },
    {
      path: '/invoice/:invoice',
      name: 'invoice',
      component: Invoice,
      props: true 
    },
    {
      path: '/mobile-checkout/:layer',
      name: 'MobileCheckout',
      props: unstableJson,
      component: MobileCheckout 
    },
    {
      path: '/cart/:layer',
      name: 'cart',
      props: unstableJson,
      component: Cart 
    },
    {
      path: '/mobile-cart/:layer',
      name: 'mobileCart',
      props: unstableJson,
      component: MobileCart 
    },
    {
      path: '/thankyou',
      name: 'thankyou',
      component: ThankYou 
    },
    {
      path: '/mobile-thankyou',
      name: 'mobilethankyou',
      component: MobileThankYou 
    },
    {
      path: '/goodauth',
      name: 'goodauth',
      component: GoodAuth
    },
    {
      path: '/badauth',
      name: 'badauth',
      component: BadAuth
    },
    {
      path: '/auth',
      name: 'auth',
      component: Auth
    },
    {
      path: '/mobile-work',
      name: 'Mobilework',
      component: Mobilework 
    }
    ,
    {
      path: '/disclaimer',
      name: 'Disclaimer',
      component: Disclaimer 
    }
    ,
    {
      path: '/faq',
      name: 'Faq',
      component: Faq 
    }

  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js